export function getLogStatus(status: boolean) {
  return status ? 'log-success' : 'log-fail';
}
